module.exports = __webpack_public_path__ + "img/reset_successful.8c44fb75.svg";